import Vue from 'vue';
import Router from 'vue-router';

import Main from './components/Main';
import Download from './components/Download';
import Privacy from './components/PrivacyPolicy'
import NotFound from './components/404'
import About from './components/About'
import Contact from './components/Contact'
import Terms from './components/Terms'
import Thanks from './components/Thanks'

Vue.use(Router);

export default new Router({
    mode: 'history',
    //base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Main
        },
        {
            path: '/r/*',
            name: 'download',
            component: Download
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '/tos',
            name: 'terms',
            component: Terms
        },
        {
            path: '/thanks',
            name: 'thanks',
            component: Thanks
        },
        {
            path: '*',
            name: 'Not Found',
            component: NotFound
        },
    ]
});